module.exports = __webpack_public_path__ + "static/media/NathanHallResume.ead08140.png";